import React from 'react';
import { Link } from 'react-router-dom';
import { SectionCard } from '../common/SectionCard';
import { SeverityPill } from '../common/StatusPills';
import type { ApplicationRecord } from '../../types/domain';
const severityRank = {
  critical: 0,
  high: 1,
  medium: 2
};
export function RiskWatchlist({
  records
}: {
  records: ApplicationRecord[];
}) {
  const flags = records.flatMap(record => record.flags.map(flag => ({
    record,
    flag
  }))).filter(({
    flag
  }) => flag.severity !== 'medium').sort((a, b) => severityRank[a.flag.severity] - severityRank[b.flag.severity]).slice(0, 6);
  const critical = records.reduce((sum, record) => sum + record.flags.filter(flag => flag.severity === 'critical').length, 0);
  return <SectionCard title="Risk watchlist" description={`${critical} critical and ${flags.filter(({
    flag
  }) => flag.severity === 'high').length}+ high-severity AI flags across live records`} bodyClassName="p-0" data-id="element-653" data-mp="31113x5i2f0mb">
      <ul className="divide-y divide-border" data-id="element-654" data-mp="2sjggnalmgwrm">
        {flags.map(({
        record,
        flag
      }) => <li key={flag.id} data-id="element-655" data-mp="2njc8q8ys5ad0">
            <Link to={`/applications/${record.id}`} className="flex items-start justify-between gap-3 px-4 py-2.5 hover:bg-muted" data-id="element-656" data-mp="2nj2gsfu6ct4o">
              <div className="min-w-0" data-id="element-657" data-mp="2ejp4lfeo1qg9">
                <p className="text-[12px] font-medium leading-snug" data-id="element-658" data-mp="2ekqirsqzat27">{flag.label}</p>
                <p className="truncate text-[11px] text-muted-foreground" data-id="element-659" data-mp="3b84wvj95udx2">{record.eventName}</p>
              </div>
              <SeverityPill severity={flag.severity} data-id="element-660" data-mp="378ctdkymixyk" />
            </Link>
          </li>)}
      </ul>
    </SectionCard>;
}